/* This main entry point component which is loaded in wix-docs */
import './tailwind-no-preflight.css';

import { CSS_CDN_URL } from '@wix/design-system';
import React from 'react';

import { addStyleLink } from './common/add-style-link';
import { BiProvider } from './common/bi-context';
import { demoContent } from './common/demo-content';
import { getLinkToCurrentFileCss } from './common/get-link-to-current-file-css';
import { PlaygroundComponent } from './common/playground-component';
import { useCssState } from './common/use-css-state';
import { defaultPluginSettings } from './common/use-parsed-plugins';

const main_css_url = getLinkToCurrentFileCss(import.meta.url);

// Style loading is in module scope to start it as soon as possible
addStyleLink(main_css_url);
addStyleLink(CSS_CDN_URL);

export const RicosApiIntroComponent = () => {
  const [containerRef, setContainerRef] = React.useState<HTMLDivElement | null>(null);

  const cssState = useCssState(CSS_CDN_URL);
  const mainCssState = useCssState(main_css_url);

  if (cssState === 'error') {
    throw new Error('Component failed to load WDS CSS');
  }
  if (mainCssState === 'error') {
    throw new Error('Component failed to load main CSS:' + main_css_url);
  }
  if (cssState === 'loading' || mainCssState === 'loading') {
    return null;
  }

  return (
    <BiProvider containerId="intro-component">
      <div ref={setContainerRef} data-hook="ricos-playground-intro-component">
        {containerRef && (
          <PlaygroundComponent
            initialContent={demoContent}
            style={{ height: '600px' }}
            variant="intro"
            containerRef={containerRef}
            plugins={defaultPluginSettings}
          />
        )}
      </div>
    </BiProvider>
  );
};

export default React.memo(RicosApiIntroComponent, () => true);
